import React from "react";
import MomentumSleevePanel from "../components/MomentumSleevePanel";

export default function MomentumSleevePage({ onNavigate }) {
  return <MomentumSleevePanel onNavigate={onNavigate}/>;
}
